import React from 'react';
import { useFela } from 'react-fela';
import { Icon } from '../../common';
import { useOptions } from '../../../OptionsContext';
import platform, { OS_TYPES } from '../../../../player/utils/platform';

/**
 * https://material.io/icons/#ic_close
 */
function CloseIcon(props) {
  return (
    <Icon {...props}>
      <path
        d="M7.9999 8.6374L2.3124 14.3249C2.1499 14.4874 1.96032 14.5687 1.74365 14.5687C1.52699 14.5687 1.3374
        14.4874 1.1749 14.3249C1.0124 14.1624 0.931152 13.9728 0.931152 13.7562C0.931152 13.5395 1.0124 13.3499 1.1749
        13.1874L6.8624 7.4999L1.1749 1.8124C1.0124 1.6499 0.931152 1.46032 0.931152 1.24365C0.931152 1.02699 1.0124 0.837402
        1.1749 0.674902C1.3374 0.512402 1.52699 0.431152 1.74365 0.431152C1.96032 0.431152 2.1499 0.512402 2.3124 0.674902L7.9999
        6.3624L13.6874 0.674902C13.8499 0.512402 14.0395 0.431152 14.2562 0.431152C14.4728 0.431152 14.6624 0.512402 14.8249
        0.674902C14.9874 0.837402 15.0687 1.02699 15.0687 1.24365C15.0687 1.46032 14.9874 1.6499 14.8249 1.8124L9.1374
        7.4999L14.8249 13.1874C14.9874 13.3499 15.0687 13.5395 15.0687 13.7562C15.0687 13.9728 14.9874 14.1624 14.8249
        14.3249C14.6624 14.4874 14.4728 14.5687 14.2562 14.5687C14.0395 14.5687 13.8499 14.4874 13.6874 14.3249L7.9999 8.6374Z"
        fill="white"
      />
    </Icon>
  );
}

const rules = ({ theme, isMobile }) => ({
  color: 'white',
  cursor: 'pointer',
  marginRight: '-6px',
  opacity: theme.opacity.enabled,
  transition: theme.transition.default,
  ':hover': {
    opacity: theme.opacity.hovered,
  },
  extend: [
    {
      condition: isMobile,
      style: {
        opacity: theme.opacity.hovered,
      },
    },
  ],
});

function Close() {
  const isMobile = [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os);
  const options = useOptions();
  const { css } = useFela({ isMobile });

  if (!options.closeMiniPlayer) {
    return null;
  }

  return (
    <CloseIcon className={css(rules)} onClick={options.closeMiniPlayer} />
  );
}

export default React.memo(Close);
